<template>
	<div class="jewelry_filter_box">
		<div class="mobile_overlay" @click="toggleFilterVisibility" :class="{'show_overlay': showMobileFilters}"></div>
		<div class="filter_overlay" :class="{ 'cyo_jew_mobile': !showMobileFilters }">
			<div class="filter_pop">

				<div class="filter_close">
					<div class="close_title">
						<SvgHeaderSvg class="for_mobile" :type="'filter_burger'" />
						<p class="mb-0 font-active">Filters</p>
						
					</div>
					<div class="close_icons">
						<div class="reset" @click="resetFilters"> <SvgHeaderSvg :type="'loader'" />&nbsp;&nbsp;Reset</div>
						<div class="for_mobile" @click="toggleFilterVisibility"><SvgHeaderSvg :type="'close'" /></div>
					</div>
				</div>

				<div class="for_mobile option_block">
					<div @click="mobileFilterBasic" :class="{ active: filterMobile }" class="opt_btn opt_btn_left_radius">basic</div>
					<div @click="mobileFilterAdvance" :class="{ active: !filterMobile }" class="opt_btn opt_btn_right_radius">advanced</div>
				</div>

				<div key="diamfilter_1" v-if="filterMobile" class="row mb-3 filter_row_block">
					<div class="col-lg-4 col-md-6 padd_mob padd_desk">
						<DiamondFilterBoxFilter :name="'shape'" />
					</div>
					<div class="col-lg-4 col-md-6 padd_mob padd_desk">
						<DiamondFilterSliderNumericSlider :name="'price'" />
					</div>
					<div class="col-lg-4 col-md-6 padd_mob padd_desk">
						<DiamondFilterSliderNumericSlider :name="'carat'" />
					</div>
					<div class="col-lg-4 col-md-6 padd_mob">
						<DiamondFilterSliderAlphaSlider :name="'color'" />
					</div>
					<div class="col-lg-4 col-md-6 padd_mob">
						<DiamondFilterSliderAlphaSlider :name="'cut'" />
					</div>
					<div class="col-lg-4 col-md-6 padd_mob">
						<DiamondFilterSliderAlphaSlider :name="'clarity'" />
					</div>
				</div>

				<div class="advance_filter for_desktop" @click="advancedFilter">
					<div class="mb-0 adv_title font-active">Advanced Filters</div>
					<div class="adv_line"></div>
					<div class="adv_icon">
						<SvgHeaderSvg v-if="togglers.advancedFilter" :type="'up'" />
						<SvgHeaderSvg v-else :type="'down'" />
					</div>
				</div>

				<div key="diamfilter_2" class="row filter_row_block filter_row_block_mod" v-if="togglers.advancedFilter">
					<div class="col-lg-4 col-md-6 padd_mob">
						<DiamondFilterSliderNumericSlider :name="'depth'" />
					</div>
					<div class="col-lg-4 col-md-6 padd_desk">
						<DiamondFilterSliderAlphaSlider :name="'polish'" />
					</div>
					<div class="col-lg-4 col-md-6 padd_mob">
						<DiamondFilterSliderNumericSlider :name="'ratio'" />
					</div>
					<div class="col-lg-4 col-md-6 padd_mob">
						<DiamondFilterSliderAlphaSlider :name="'fluorescence'" />
					</div>
					<div class="col-lg-4 col-md-6 padd_mob">
						<DiamondFilterSliderNumericSlider :name="'table'" />
					</div>
					<div class="col-lg-4 col-md-6">
						<DiamondFilterSliderAlphaSlider :name="'symmetry'" />
					</div>
					<div class="col-lg-4 col-md-6">
						<DiamondFilterCheckboxFilter :name="'report'" />
					</div>
				</div>

			</div>
		</div>

		<!-- <div class="for_mobile diamond_open" v-if="!showMobileFilters" @click="toggleFilterVisibility">
			<SvgHeaderSvg :type="'filter'" /> <span class="ms-2">FILTER RESULTS ({{ resultCount }})</span>
		</div>

		<div class="for_mobile diamond_open diamond_open_mod" @click="toggleFilterVisibility" v-else>
			<span>APPLY FILTERS ({{ appliedFiltersCount }})</span>
		</div> -->

		<div v-if="!showMobileFilters" class="for_mobile sticky_btns w-100">
            <CommonButtonPrimary  @emit-event="toggleFilterVisibility()">
                <SvgHeaderSvg :type="'filter'" /> <span class="ms-2">FILTER RESULTS {{ resultCount && `(${resultCount})` }}</span> 
            </CommonButtonPrimary>
        </div>
        <div v-else  class="for_mobile sticky_btns sticky_btns_mod">
            <CommonButtonPrimary @emit-event="toggleFilterVisibility()" ><span>APPLY FILTERS </span></CommonButtonPrimary>
			<!-- ({{ appliedFiltersCount}}) -->
        </div>
	</div>
</template>

<script setup>
	//   import { ref, reactive } from 'vue';
  	import {cyolistStore}  from '@/stores/cyolist/cyolist';
    
  	const store = cyolistStore();

	const advancedFilter = () => {
		props.togglers.advancedFilter = !props.togglers.advancedFilter
	}

	const props = defineProps({
		togglers: {
			type: Object,
			required: true
		}
	});

	const showMobileFilters = ref(false);
	const filterMobile = ref(true);

	const resultCount = computed(() => {
		return store.getSettingListingResultCount();
	});
    const options =  computed(()=> store.getSettingAllFilterOptions())
	
	// const appliedFiltersCount = computed(()=>{
	// 	let tags = []

	// 	if(options.value){
	// 		Object.keys(options.value).filter((filtersKey)=>{
				
	// 			const obj = options.value[filtersKey]
	// 			const objectKeysToExclude = ['sortV2', 'sort','report', 'quickship', 'listview','blockchain']
				

	// 			if(!objectKeysToExclude.includes(filtersKey)){
	// 				if(Array.isArray(obj)){
	// 					obj.filter((item) => {
	// 						if (item.active) {
	// 							console.log(item, ":", filtersKey,'is array active')
	// 							tags.push(true)
	// 						}
	// 					})
	
	// 				}else if(typeof obj === 'object' && obj !== null) {
	
	// 					if (obj.from != obj.min || obj.to != obj.max) {
	// 						tags.push(true)
	// 					}
	// 				}
	// 			}
	// 		})
	// 	}

    // 	return tags.length;
	// })

	const resetFilters = () => {
		window.location = window.location.pathname;
	};

	const toggleFilterVisibility = () => {
	
		showMobileFilters.value = !showMobileFilters.value;
		if (!showMobileFilters.value) {
			window.scrollTo({ top: 0, behavior: 'smooth' });
			document.body.classList.remove('filter_open');
		}
		if (showMobileFilters.value) {
			document.body.classList.add('filter_open');
		}
	};

	const mobileFilterBasic = () => {
		filterMobile.value = true;
		props.togglers.advancedFilter = false;
	};

	const mobileFilterAdvance = () => {
		filterMobile.value = false;
		props.togglers.advancedFilter = true;
	};
</script>

<style scoped>

.opt_btn_left_radius{
	border-radius: 4px 0px 0px 4px ;
}
.opt_btn_right_radius{
	border-radius: 0px 4px 4px 0px ;
}
.advance_filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
	/* margin: 0 0 20px 0; */
}
.adv_title{
	font-size: 18px;
}
.adv_line {
	border-top: 1px solid #eaeaea;
	width: 85%;
}
.padd_desk {
  	padding-bottom: 20px;
}
.checkbox_custom {
	font-size: 14px;
	font-weight: 600;
}
.jewelry_filter_box {
    /* margin-top: 4%;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    padding: 2.5%; */
}
.sticky_btns button {
        width: 100%;
}

.sticky_btns button:focus{
    box-shadow: none;
}

.filter_row_block.filter_row_block_mod {
    margin-top: 20px;
}
.center_col {
  	padding: 0 2% !important;
}
.left_col {
  	padding-right: 2% !important;
}
.right_col {
  	padding-left: 2% !important;
}

.filter_close {
	display: flex !important;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 10px;
}
.filter_close svg {
	transform: scale(1.3);
}
.close_title {
	display: flex;
	align-items: center;
	justify-content: center;
}
.close_title .svg-head {
	height: 15px;
}
.close_title p {
	font-size: 20px;
}
.close_icons {
	display: flex;
	align-items: center;
}
.reset {
	font-size: 14px;
	color: #212529;
	margin-top: 2px;
	margin-right: 7px;
	cursor: pointer;
    display: flex;
    align-items: center;
}

.reset .svg-head {
	margin-right: 4px;
	transform: scale(0.7);
}

@media (max-width: 1150px){
	.adv_line {
		width: 75%;
	}
}

@media (max-width: 767px) {
	.filter_row_block.filter_row_block_mod {
		margin-top: 0;
	}

	.filter_close {
		border-bottom: 1px solid #eaeaea;
        padding: 20px;
	}
	.close_title .svg-head {
		height: 15px;
		margin-right: 10px;
	}

	.close_title p {
		font-size: 14px;
		font-weight: 600;
		font-family: 'Lato';
	}

	.reset {
		margin-right: 20px;
	}
	.for_mobile.option_block {
		display: flex !important;
		align-items: center;
	}
	.padd_mob {
		padding-bottom: 22px;
  	}
	
	.jewelry_filter_box {
		position: fixed;
		bottom: 0;
		width: 100%;
		left: 0;
		z-index: 99;
	}
	
	.filter_pop {
		background: #fff;
		height: 80vh;
		border-radius: 10px 10px 0 0;
		width: 100%;
	}
	.filter_row_block {
		padding: 0 4% 35% 4%;
		max-height: 70vh;
		min-height: 70vh;
		overflow-y: auto;
		overflow-x: hidden;
	}
	.option_block {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 4%;
	}
	.opt_btn {
		width: 50%;
		text-align: center;
		text-transform: uppercase;
		font-size: 14px;
		font-weight: 600;
		background: #d6d6d6;
		padding: 5px;
		color: #fff;
	}
	.opt_btn.active {
		background: var(--green);
	}
	.reset_filter {
		display: flex !important;
		align-items: center;
		justify-content: flex-end;
		font-size: 14px;
		font-weight: 700;
		padding-right: 17px;
		margin-top: 4%;
	}
	.diamond_open {
		background: var(--green) !important;
		border-color: none;
		text-transform: uppercase;
		font-size: 14px !important;
		border: none;
		font-weight: 600;
		letter-spacing: 0.5px;
		line-height: 1;
		color: #fff;
		width: 100%;
		display: flex !important;
		align-items: center;
		justify-content: center;
		height: 45px;
	}

	.sticky_btns.sticky_btns_mod {
        z-index: 99;
        padding: 0;
		/* border-radius: 0; */
    }
   
    .sticky_btns.sticky_btns_mod button{
        border-radius: 0;
    }

	.sticky_btns {
        position: fixed;
        bottom: 0;
        width: 100%;
        left: 0;
        z-index: 9;
        padding: 16px 16px 16px 16px;
        border-radius: 16px 16px 0px 0px;
        background-color: #fff;
        box-shadow: 0px -2px 10px 0px #00000026;
		transition: 1s;
    }
	.adv_line {
		width: 75%;
	}
	.filter_overlay {
		position: fixed;
        bottom: 0;
        width: 100%;
        height: auto;
        z-index: -1;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        transition: 0.3s;
	}
}
@media screen and (max-width: 767px) {
	.mobile_overlay.show_overlay {
		position: fixed;
		top: 0;
		left: 0;
		height: 0;
		width: 100%;
		background: #0000007a;
		z-index: -1;
		transition: 0.1s;
	}
	.mobile_overlay.show_overlay {
		transition: 0.1s;
		height: 100%;
	}
	.cyo_jew_mobile.filter_overlay {
		transition: 0.3s;
        position: fixed;
        bottom: -100%;
		height: 0;
	}
}
</style>
